module.exports = __webpack_public_path__ + "static/media/gada.dbff8a28.png";